import { Injectable } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { ApiService } from 'src/app/core/service/api.service';
import { environment } from 'src/environments/environment';
import { DatePipe } from '@angular/common';
import * as moment from 'moment';
import { ConfigService } from 'src/app/core/service/config.service';

@Injectable({
  providedIn: 'root'
})
export class ApiRoomsService {

  constructor(private apiService: ApiService, private _DatePipe: DatePipe, private _config: ConfigService) { }

  allRooms(modal: any) {
    return this.apiService
      .get(`${environment.apiUrl}auction/rooms`, modal)
      .pipe(catchError(this.handleError));
  }

  allRoomForAdmin(modal: any) {
    modal.start_date = modal.start_date ? moment(modal.start_date).format('YYYY-MM-DD') : '';
    modal.end_date = modal.end_date ? moment(modal.end_date).format('YYYY-MM-DD') : '';
    return this.apiService
      .get(`${environment.apiUrl}admin/auction/rooms`, modal)
      .pipe(catchError(this.handleError));
  }

  // getRoom_auctions_ForAdmin(modal: any) {
  //   modal.start_date = modal.start_date ? moment(modal.start_date).format('YYYY-MM-DD') : modal.start_date;
  //   modal.end_date = modal.end_date ? moment(modal.start_date).format('YYYY-MM-DD') : modal.end_date;
  //   return this.apiService
  //     .get(`${environment.apiUrl}admin/auction/auctions`, modal)
  //     .pipe(catchError(this.handleError));
  // }

  // getRoomAuctionsfor_anonymous(modal: any) {
  //   modal.start_date = modal.start_date ? moment(modal.start_date).format('YYYY-MM-DD') : modal.start_date;
  //   modal.end_date = modal.end_date ? moment(modal.start_date).format('YYYY-MM-DD') : modal.end_date;
  //   return this.apiService
  //     .get(`${environment.apiUrl}auction/auctions`, modal)
  //     .pipe(catchError(this.handleError));
  // }

  deleteRoom(roomId: string) {
    return this.apiService
      .remove(`${environment.apiUrl}admin/auction/rooms/${roomId}`)
      .pipe(catchError(this.handleError));
  }

  changeRoomStatus(roomId: string) {
    return this.apiService
      .update(`${environment.apiUrl}admin/auction/rooms/change-status/${roomId}`)
      .pipe(catchError(this.handleError));
  }

  showRoom(roomId: string) {
    return this.apiService
      .get(`${environment.apiUrl}admin/auction/rooms/${roomId}`)
      .pipe(catchError(this.handleError));
  }

  addRoom(model: any) {
    console.log(model);
    model.start_date = this._DatePipe.transform(model?.start_date, 'yyyy-MM-dd')
    model.end_date = this._DatePipe.transform(model?.end_date, 'yyyy-MM-dd')
    model.permitting_without_enough_balance = model?.permitting_without_enough_balance ? 1 : 0
    model.is_multi_auction = model?.is_multi_auction ? 1 : 0
    const formData = new FormData();
    formData.append("name_ar", model?.name_ar)
    formData.append("name_en", model?.name_en)
    formData.append("description_ar", model?.description_ar)
    formData.append("description_en", model?.description_en)
    formData.append("start_date", model?.start_date)
    if (model?.end_date) {
      formData.append("end_date", model?.end_date ? model?.end_date : '')
    }
    formData.append("permitting_without_enough_balance", model?.permitting_without_enough_balance)
    formData.append("is_percentage", model?.is_percentage)
    formData.append("permitting_value", model?.permitting_value)
    formData.append("image", model?.bannerImage ? model?.bannerImage : null)
    formData.append("small_image", model?.smallImage ? model?.smallImage : null)
    formData.append("start_at", model?.start_at)
    formData.append("interval_between_items", model?.interval_between_items)
    formData.append("time_between_items", model?.time_between_items)
    formData.append("interval_end_item", model?.interval_end_item)
    formData.append("end_time_if_no_bid", model?.end_time_if_no_bid)
    formData.append("entry_fee", model?.entry_fee)
    formData.append("is_multi_auction", model?.is_multi_auction)


    return this.apiService
      .post(`${environment.apiUrl}auction/rooms`, formData)
      .pipe(catchError(this.handleError));
  }


  updateRoom(model: any) {
    model.start_date = this._DatePipe.transform(model?.start_date, 'yyyy-MM-dd');
    model.end_date = this._DatePipe.transform(model?.end_date, 'yyyy-MM-dd');
    model.permitting_without_enough_balance = model?.permitting_without_enough_balance ? 1 : 0;
    model.is_multi_auction = model?.is_multi_auction ? 1 : 0;
    const formData = new FormData();
    formData.append("name_ar", model?.name_ar)
    formData.append("name_en", model?.name_en)
    formData.append("description_ar", model?.description_ar)
    formData.append("description_en", model?.description_en)
    formData.append("start_date", model?.start_date)
    if (model?.end_date) {
      formData.append("end_date", model?.end_date ? model?.end_date : '')
    }
    formData.append("permitting_without_enough_balance", model?.permitting_without_enough_balance)
    formData.append("is_percentage", model?.is_percentage)
    formData.append("permitting_value", model?.permitting_value)
    formData.append("image", model?.bannerImage ? model?.bannerImage : '')
    formData.append("small_image", model?.smallImage ? model?.smallImage : '')
    formData.append("start_at", model?.start_at)
    formData.append("interval_between_items", model?.interval_between_items)
    formData.append("time_between_items", model?.time_between_items)
    formData.append("interval_end_item", model?.interval_end_item)
    formData.append("end_time_if_no_bid", model?.end_time_if_no_bid)
    formData.append("entry_fee", model?.entry_fee ? model?.entry_fee : '')
    formData.append("is_multi_auction", model?.is_multi_auction)
    formData.append("_method", "Put")
    // formData.append("description_en", model?.description_en)
    // formData.append("image", model?.files[0])
    return this.apiService
      .post(`${environment.apiUrl}auction/rooms/${model?.id}`, formData)
      .pipe(catchError(this.handleError));
  }

  getCategories() {
    return this.apiService
      .get(`${environment.apiUrl}auction/categories?perPage=20&sort=ASC`)
      .pipe(catchError(this.handleError));
  }

  publishAuction(model: any) {
    return this.apiService
      .update(`${environment.apiUrl}admin/auction/rooms/publish/${model?.id}`)
      .pipe(catchError(this.handleError));
  }

  unPublishAuction(model: any) {
    return this.apiService
      .update(`${environment.apiUrl}admin/auction/rooms/unpublish/${model?.id}`)
      .pipe(catchError(this.handleError));
  }


  GetRoomAuctions(modal: any) {
    let authUser = this._config.getAuthUserInfo()
    modal.start_date = modal.start_date ? moment(modal.start_date).format('YYYY-MM-DD') : modal.start_date;
    modal.end_date = modal.end_date ? moment(modal.end_date).format('YYYY-MM-DD') : modal.end_date;
    delete modal.user_id

    modal.filterType ? modal.type = modal.filterType : delete modal.type
    delete modal.filterType
    if (authUser?.user && authUser?.user?.role_code != "General") {
      return this.apiService
        .get(`${environment.apiUrl}admin/auction/auctions`, modal)
        .pipe(catchError(this.handleError));
    } else {
      modal.exclude_completed_item = true;
      return this.apiService
        .get(`${environment.apiUrl}auction/auctions`, modal)
        .pipe(catchError(this.handleError));
    }
  }

  OnResumeOrPause(roomId: string) {
    return this.apiService
      .post(`${environment.apiUrl}admin/auction/rooms/pause-resume/${roomId}`)
      .pipe(catchError(this.handleError));
  }
  handleError(error: any) {
    return throwError(error);
  }
}


